import { useEffect } from 'react';

import { configString } from 'config/appConfigUtils';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

export function LoggedInStylesLoader() {
  const { user } = useUserEnvironment();

  useEffect(() => {
    if (!user) return;

    /**
     * Only load style.css when the user is logged in.
     *
     * This file includes CSS that only needs to be used by logged-in users.
     */
    const styleEl = document.createElement('link');
    styleEl.href = `${configString('idealist', 'staticJsPath')}../style.css`;
    styleEl.type = 'text/css';
    styleEl.rel = 'stylesheet';
    document.head.appendChild(styleEl);
  }, [user]);

  return null;
}
